// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".379c50e5f050afe6ff724a5ecdcb309326813eaa.chunk.js";
};